export const environment = {
  production: true,
  logStoreActions: false,
};
